import React, {FC} from 'react';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RuleEditorConditionsGroupsEnum} from '../ruleConditionModel';

/*
 * Types.
 */

interface RuleActionConditionGroupIconProps {
  id: RuleEditorConditionsGroupsEnum | string;
}

/*
 * Component.
 */

export const RuleActionConditionGroupIcon: FC<RuleActionConditionGroupIconProps> = ({id}) => {
  const theme = useUserTheme();
  return <Icon name={getIconName(id)} color={theme.greys.shade80} />;
};

/*
 * Helpers.
 */

export const getIconName = (id: RuleEditorConditionsGroupsEnum | string): IconName => {
  switch (id) {
    case 'suggested':
      return 'lightbulb';

    case RuleEditorConditionsGroupsEnum.INBOX:
      return 'inboxFilled';

    case 'organization':
    case RuleEditorConditionsGroupsEnum.TAGS:
      return 'tagFilled';

    case RuleEditorConditionsGroupsEnum.TIME:
      return 'snoozeFilled';

    case RuleEditorConditionsGroupsEnum.MESSAGE:
      return 'sendFilled';

    case RuleEditorConditionsGroupsEnum.CONTACT:
    case 'contacts':
      return 'contactsFilled';

    case RuleEditorConditionsGroupsEnum.RECIPIENT:
      return 'channelEmail';

    case RuleEditorConditionsGroupsEnum.TEAMMATES:
      return 'teammatesFilled';

    case RuleEditorConditionsGroupsEnum.CONTENT:
      return 'content';

    case RuleEditorConditionsGroupsEnum.STATUS:
      return 'archiveFilled';

    case RuleEditorConditionsGroupsEnum.EXPRESSION:
      return 'variable';

    case RuleEditorConditionsGroupsEnum.ACCOUNT:
      return 'briefcaseFilled';

    case 'third-party':
      return 'sequences';

    default:
      return 'inboxFilled';
  }
};
